package io.horion.cv.api.datasource.common

import kotlinx.serialization.Serializable

@Serializable
data class PersonalInformation(
    val firstName: String = "",
    val lastName: String = "",
    val phone: String = "",
    val email: String = "",
    val sex: String = "",
    val photo: String = "",
    val address: String = "",
    val bp: String = "",
    val qrCodePath: String = "images/qr-code.png",
    val city: String = "",
    val state: String = "",
    val country: String = "",
    val nationality: String = "",
    val birth: String = "",
    val drivingLicense: String = "",
    val maritalStatus: String = "",
    val siteWeb: Pair<String, String>? = null,
    val links: List<Pair<String, String>> = emptyList(),
    val labels: List<String> = emptyList(),
)